import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function CityDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const cityDetails = location.state?.cityDetails || {};

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/city-master")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                City Details of : {cityDetails.city_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Country Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="country_name"
                                                        readOnly
                                                        value={cityDetails.country_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">State Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="state_name"
                                                        readOnly
                                                        value={cityDetails.state_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">City Name</label>
                                                    <input
                                                        type="text"
                                                        name="city_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={cityDetails.city_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={cityDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CityDetails
